require('./insuranceRequestDetailsTabsWrapper.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const InsuranceRequestDetailsTabs = require('../insuranceRequestDetails/insuranceRequestDetailsTabs');
const InsuranceRequestRelatedLeaveModalWrapper = require('../insuranceRequestWizard/insuranceRequestRelatedLeaveModalWrapper/insuranceRequestRelatedLeaveModalWrapper')
const InsuranceRequestBuildPaymentType = require('../insuranceRequestWizard/insuraceRequestBuildPaymentType/insuranceRequetsBuildPaymentType');
const InsuranceRequestWizardStep3PlanModal = require('../insuranceRequestWizard/insuranceRequestWizardStep3/insuranceWizardStep3Components/insuranceRequestWizardStep3PlanModal');

// @ constants
const { PLANS: { BASIC }, PAYMENT_TYPE } = require('../../insuranceConstants/insuranceRequestHome');
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP } = require('constants/index');
const { INSURANCE_USABILITY_IMPROVEMENTS } = require('constants/flagBasedFeatures');

class InsuranceRequestDetailsTabsWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showRncPaymentTypeModal: false,
            nextButtonClicked: false
        };

        this.handleBackButtonCallback = this.handleBackButtonCallback.bind(this);
        this.handleNextButtonCallback = this.handleNextButtonCallback.bind(this);
        this.handleNextButtonCallbackRnc = this.handleNextButtonCallbackRnc.bind(this);
        this.handleToggleModalRncPaymentType = this.handleToggleModalRncPaymentType.bind(this);
        this.onHandleRncPaymentTypeChange = this.onHandleRncPaymentTypeChange.bind(this);
        this.handleModalNextButtonCallbackRnc = this.handleModalNextButtonCallbackRnc.bind(this);
        this.onHandleModalClose = this.onHandleModalClose.bind(this);
        this.handleInsurancePlanModal = this.handleInsurancePlanModal.bind(this);
    }

    componentWillReceiveProps() {
        const { immInsuranceWizard, onChangeShowCoverageDetailTable, isPostAppraisal } = this.props;
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        if (associatingClient && this.state.nextButtonClicked && !isPostAppraisal) {
            onChangeShowCoverageDetailTable();
        }
    }

    componentWillUnmount() {
        const { linkClientSuccessInitialState } = this.props;
        this.setState({ nextButtonClicked: false });
        linkClientSuccessInitialState();
    }

    handleNextButtonCallback(selectedPlan) {
        const {
            currentPlan,
            onhandleSelectPlanInDetailTable,
            setData,
            didPlanChangeIndetailTable
        } = this.props;

        const chosenPlan = currentPlan || selectedPlan;
        const selectedPlanInDetailTable = didPlanChangeIndetailTable ? selectedPlan : chosenPlan;
        this.setState({ nextButtonClicked: true });

        if (selectedPlan !== currentPlan) {
            setData(FOURTH_STEP, {
                paymentType: PAYMENT_TYPE.ANNUAL
            });
        }

        onhandleSelectPlanInDetailTable(selectedPlanInDetailTable);
    }

    handleNextButtonCallbackRnc(selectedPlan) {
        const {
            immFlagBasedFeatures,
            onhandleSelectPlanInDetailTable,
            setData,
        } = this.props;
        const insuranceUsabilityImprovementsFlag = !!immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);

        if (insuranceUsabilityImprovementsFlag && selectedPlan === BASIC) {
            onhandleSelectPlanInDetailTable(selectedPlan);
            setData(THIRD_STEP, { basicPlanModalValidation: true });
        } else {
            onhandleSelectPlanInDetailTable(selectedPlan);
            this.setState({ showRncPaymentTypeModal: true });
        }
    }

    handleModalNextButtonCallbackRnc(selectedPlan, paymentSelected) {
        const { onhandleSelectPlanInDetailTable } = this.props;

        onhandleSelectPlanInDetailTable(selectedPlan, paymentSelected);
    }

    handleBackButtonCallback() {
        const { onChangeShowCoverageDetailTable, setData } = this.props;

        setData(THIRD_STEP, {
            step3LoadingFromDetailsTable: true
        });

        onChangeShowCoverageDetailTable();
    }

    handleToggleModalRncPaymentType() {
        this.setState({ showRncPaymentTypeModal: false });
    }

    onHandleRncPaymentTypeChange(paymentType = '') {
        const { setData, immInsuranceState, immInsuranceWizard } = this.props;

        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);

        const plan = immInsuranceState.getIn(['data', 'insurancePlan']);
        const planLowerCase = plan && plan.toLowerCase()
        const totalCost = immInsuranceWizardStep3.getIn(['pricing', paymentType.toLowerCase(), planLowerCase, 'firstImport']);

        setData(THIRD_STEP, {
            paymentType,
            totalCost
        });
    }

    buildRncPaymentTypeModal(associatingClient) {
        const { selectedPlan, isRelated, isRnc, immInsuranceState, immInsuranceWizard } = this.props;

        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const paymentSelected = immInsuranceWizardStep3.get('paymentType');

        const modalButtons = !immInsuranceWizardStep3.get('isFetchingPricing') && (
            <div className="coverages-detail-view__bottom-buttons coverages-detail-view__bottom-buttons--modal">
                <div className="coverages-detail-view__bottom-left">
                    <OKButton
                        modifier="link-ghost"
                        onClick={this.handleToggleModalRncPaymentType}
                    >
                        <FormattedText value="buttonsActions-cancel" format="firstUppercase" />
                    </OKButton>
                </div>
                <div className="coverages-detail-view__bottom-right">
                    <OKButton
                        id="btnRncPamentModalNext"
                        size="regular"
                        modifier="primary"
                        loading={associatingClient}
                        disabled={!paymentSelected}
                        onClick={() => this.handleModalNextButtonCallbackRnc(selectedPlan, paymentSelected)}
                    >
                        <FormattedText value="buttonsActions-next" format="firstUppercase" />
                    </OKButton>
                </div>
            </div>
        );

        const message = !immInsuranceWizardStep3.get('isFetchingPricing') && (
            <OKMessage>
                <FormattedText value="mortgageRequestInsuranceRnc-step3PaymentDisclaimer" />
            </OKMessage>
        );

        return (
            <ModalCustom
                extraClass="col-md-7 coverages-detail-view__modal"
                isOpen={this.state.showRncPaymentTypeModal}
            >
                <section className="coverages-detail-view__modal-section">
                    <InsuranceRequestBuildPaymentType
                        isRnc={isRnc}
                        paymentSelected={paymentSelected}
                        immInsuranceState={immInsuranceState}
                        immInsuranceWizardStep={immInsuranceWizardStep3}
                        isRelated={isRelated}
                        onhandlePaymentTypeChange={this.onHandleRncPaymentTypeChange}
                        onhandleAccountChange={this.onhandleAccountChange}
                    />
                </section>
                {message}
                {modalButtons}
            </ModalCustom>
        );
    }

    buildButtons(associatingClient) {
        const { selectedPlan, isRelated, isRnc, isPostAppraisal, onhandleCancel } = this.props;

        let nextButtonClick = () => this.handleNextButtonCallback(selectedPlan);

        if (isRelated && isRnc && isPostAppraisal) {
            nextButtonClick = () => this.handleNextButtonCallbackRnc(selectedPlan);
        }

        return (
            <React.Fragment>
                <div className="coverages-detail-view__bottom-left">
                    <OKButton
                        modifier="link-ghost"
                        onClick={onhandleCancel}
                    >
                        <FormattedText value="buttonsActions-cancel" format="firstUppercase" />
                    </OKButton>
                </div>
                <div className="coverages-detail-view__bottom-right">
                    <OKButton
                        modifier="ghost"
                        leftIcon="icon-anterior"
                        size="regular"
                        disabled={associatingClient}
                        onClick={this.handleBackButtonCallback}
                    >
                        <FormattedText value="insuranceRequestHome-back" />
                    </OKButton>
                    <OKButton
                        id="btnAcceptConditions"
                        size="regular"
                        modifier="secondary"
                        rightIcon="icon-siguiente"
                        loading={associatingClient}
                        onClick={nextButtonClick}
                    >
                        <FormattedText value="insuranceRequestHome-step3ApplyFor" />
                    </OKButton>
                </div>
            </React.Fragment>
        );
    }

    onHandleModalClose() {
        const { setData } = this.props;
        setData(THIRD_STEP, { basicPlanModalValidation: false });
    }

    handleRequestPlanAccept(step, acceptBasicPlan) {
        const {
            isPostAppraisal,
            isRelated,
            isRnc,
            setData,
            validateStep,
        } = this.props;
        if (isRelated && isRnc && isPostAppraisal) {
            this.setState({ showRncPaymentTypeModal: true });
            setData(THIRD_STEP, { basicPlanModalValidation: false });
        } else {
            return validateStep(step, acceptBasicPlan);
        }
    }

    handleInsurancePlanModal(immInsuranceWizardStep3) {
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        const basicPlanModalValidation = immInsuranceWizardStep3.get('basicPlanModalValidation');

        return (
            <InsuranceRequestWizardStep3PlanModal
                isOpen={basicPlanModalValidation}
                loading={associatingClient}
                handleRequestClose={this.onHandleModalClose}
                onRequestAccept={() => this.handleRequestPlanAccept(FOURTH_STEP, true)}
            />
        )
    }

    render() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            selectedPlan,
            currentPlan,
            isRelated,
            onhandleChangeSelectedPlanInStateComponent,
            clearRequest,
            cancelingSimulation
        } = this.props;

        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        const chosenPlan = currentPlan || selectedPlan;
        const tableDetailsTitle = formatText('insuranceRequestHome-step3DetailsTitle');
        const insuranceUsabilityImprovementsFlag = !!immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);

        const leaveModal = isRelated && (
            <InsuranceRequestRelatedLeaveModalWrapper
                immInsuranceWizard={immInsuranceWizard}
                clearRequest={clearRequest}
                cancelingSimulation={cancelingSimulation}
            />
        );

        return (
            <section className="col-xs-10 coverages-detail-view__main-container">
                <OKBoxTitle
                    value={tableDetailsTitle}
                    inline={true}
                >
                </OKBoxTitle>
                <header className="coverages-detail-view__table-title">
                    <FormattedText value="insuranceRequestHome-step3DetailsSubtitle" />
                </header>
                <InsuranceRequestDetailsTabs
                    insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                    isRelated={isRelated}
                    onhandleChangeSelectedPlanInStateComponent={onhandleChangeSelectedPlanInStateComponent}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardStep={immInsuranceWizardStep3}
                    propertyInformation={immInsuranceWizardStep2}
                    chosenPlan={chosenPlan}
                    selectedPlan={selectedPlan}
                />
                <div className="coverages-detail-view__bottom-buttons">
                    {this.buildButtons(associatingClient)}
                </div>
                {leaveModal}
                {this.buildRncPaymentTypeModal(associatingClient)}
                {insuranceUsabilityImprovementsFlag && this.handleInsurancePlanModal(immInsuranceWizardStep3)}
            </section>
        )
    }
}

InsuranceRequestDetailsTabsWrapper.propTypes = {
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    onhandleChangeSelectedPlanInStateComponent: PropTypes.func.isRequired,
    onhandleCancel: PropTypes.func,
    onChangeShowCoverageDetailTable: PropTypes.func.isRequired,
    onhandleSelectPlanInDetailTable: PropTypes.func.isRequired,
    isRelated: PropTypes.bool,
    isPostAppraisal: PropTypes.bool,
    immFlagBasedFeatures: PropTypes.object,
    isRnc: PropTypes.bool,
    selectedPlan: PropTypes.string,
    currentPlan: PropTypes.string,
    clearRequest: PropTypes.func,
    cancelingSimulation: PropTypes.func,
    setData: PropTypes.func.isRequired,
    didPlanChangeIndetailTable: PropTypes.bool.isRequired,
    linkClientSuccessInitialState: PropTypes.func,
    validateStep: PropTypes.func,
};

InsuranceRequestDetailsTabsWrapper.defaultProps = {
    onhandleCancel: () => { },
    isRelated: false,
    isPostAppraisal: false,
    isRnc: false,
    selectedPlan: BASIC,
    currentPlan: '',
    clearRequest: () => { },
    cancelingSimulation: () => { },
    didPlanChangeIndetailTable: false,
    linkClientSuccessInitialState: () => { },
};

module.exports = InsuranceRequestDetailsTabsWrapper;
